import { Dialog } from 'primereact/dialog';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import { selectCurrentEmpid, selectCurrentUser} from '../../../pages/login/authSlice';
import { useGetCoachingGoalQuery } from '../goals/goalSlice';
import { GoalHeader } from './GoalHeader';
import { NewRevGengoal } from './NewRevgenGoal';
import { RevGenGoalsTable } from './RevGenGoalsTable';
import { RevgenMonthlySummary } from './RevgenMonthlySummary';

interface RevGenSummaryProps {
    visible: boolean;
    closeDialog: (res: boolean) => void;
    inputMonth: number;
    inputYear: number;
    recipientDetails: any;
    revgenList: any;
    viewState?:string
}

export const RevGenSummary = ({
    visible,
    closeDialog,
    inputMonth,
    inputYear,
    recipientDetails,
    revgenList,
    viewState,
}: RevGenSummaryProps) => {
    const loggedEmpNum = useSelector(selectCurrentEmpid);
    const loggedEmpName = useSelector(selectCurrentUser);
    const [coachingGoals, setCoachingGoals] = useState<any>();
    const [goalDate, setGoalDate] = useState<Date | string>('');
    const [isNewGoal, setIsNewGoal] = useState<boolean>(false);
    const [isSupervisorReviewed, setIsSupervisorReviewed] = useState<boolean>(false);
    const [hideControls, setHideControls] = useState<boolean>(false);
    const [isAssociateAcknowledged, setIsAssociateAcknowledged] = useState<boolean>(false);
    const [month, setMonth] = useState<number>(inputMonth);
    const [year, setYear] = useState<number>(inputYear);
    const [selectedRecipientEmployee, setSelectedRecipientEmployee] = useState<any>(null);
    const [recipientList, setRecipientList] = useState<any[]>([]);
    
    const { data: coachingGoalsData } = useGetCoachingGoalQuery(
        {
            authorId: loggedEmpNum,
            recipientId: selectedRecipientEmployee?.employeeNumber ,
            year,
            month,
        },
        {
            skip: !loggedEmpNum || !month || !year,
        }
    );
    useEffect(() => {
        setGoalDate(new Date(inputYear, inputMonth - 1, 1));
    }, [inputMonth, inputYear]);

    useEffect(() => {
        setGoalDate(new Date(inputYear, inputMonth - 1, 1));
    }, [month, year]);
   
    useEffect(() => {
        if (revgenList) {
            const fetchrecipientList: any[] = revgenList?.map((item: any) => {
                return {
                    employeeNumber: item?.employee_number,
                    employeeName: item?.employee_name,
                    authorEmployeeNumber: item?.author_employee_number,
                    managerLevel: item?.manager_level,
                };
            });
            setRecipientList(fetchrecipientList);
            const selectedRecipient = fetchrecipientList?.filter(
                (item: any) => item.employeeNumber === recipientDetails?.employee_number
            );
            setSelectedRecipientEmployee(selectedRecipient?.length > 0 ? selectedRecipient[0] : null);
        }
    }, [revgenList]);

    useEffect(() => {
        setCoachingGoals(coachingGoalsData?.data?.length > 0 ? coachingGoalsData.data : []);
        setIsSupervisorReviewed(coachingGoalsData?.data[0]?.supervisor_discussed === true);
        if (isNewGoal && coachingGoalsData?.data[0]?.supervisor_discussed === true) {
            setIsNewGoal(false);
        }
        setIsAssociateAcknowledged(
            coachingGoalsData?.data[0]?.supervisor_discussed === true &&
                coachingGoalsData?.data[0]?.associate_acknowledged === true
        );
        setHideControls(
            coachingGoalsData?.data[0]?.supervisor_discussed === true &&
                coachingGoalsData?.data[0]?.associate_acknowledged === true &&
                coachingGoalsData?.data[0]?.month_end_reviewed === true
        );
        if(viewState === 'read-only'){
            setHideControls(true);
        }
       
    }, [coachingGoalsData, month, year,viewState]);

    const handleSetNewGoal = (value: boolean) => {
        setIsNewGoal(value);
    };

    const handleDateChange = (month: number, year: number) => {
        setMonth(month);
        setYear(year);
    };
    return (
        <Dialog style={{ width: '80%' }} visible={visible} onHide={() => closeDialog(true)} modal>
            <GoalHeader
                onDateChange={handleDateChange}
                setNewGoal={handleSetNewGoal}
                inputMonth={month}
                inputYear={year}
                isNewGoal={isNewGoal}
                hideNewGoalBtnPayoutTextbox={isSupervisorReviewed}
                recipientList={recipientList}
                selectedRecipientEmployee={selectedRecipientEmployee}
                setSelectedRecipientEmployee={setSelectedRecipientEmployee}
                viewState= {viewState}
            />
            <hr />
            <RevgenMonthlySummary recipientDetails={selectedRecipientEmployee} goals={coachingGoals} 
            hideControls ={hideControls}/>
            <hr />
            {!isNewGoal && (
                <RevGenGoalsTable
                    recipientDetails={selectedRecipientEmployee}
                    goals={coachingGoals}
                    hideControls={hideControls}
                    isSupervisorReviewed={isSupervisorReviewed}
                    isAssociateAcknowledged={isAssociateAcknowledged}
                    inputMonth={month}
                    inputYear={year}
                    viewState={viewState}
                />
            )}
            {isNewGoal && (
                <NewRevGengoal
                    employeeNumber={selectedRecipientEmployee?.employeeNumber}
                    goalDate={goalDate}
                    goals={coachingGoals}
                    inputMonth={month}
                    inputYear={year}
                    authorId={loggedEmpNum}
                    authorName={loggedEmpName}
                    isNewGoal={(value) => handleSetNewGoal(value)}
                    closeDialog={closeDialog}
                />
            )}
        </Dialog>
    );
};
